import React, {useEffect, useState, useRef} from "react"
import {apiGet} from "../../../Api/index";
import {Div, Text} from "atomize";
import theme from "../../../Theme/Theme";
import styled from "styled-components";
import Skeleton from "react-loading-skeleton";
import {withRouter} from "react-router";

const Wrapper = styled(Div)`
  margin-top: 6rem;
`;

const Title = styled(Text)`
  min-height: 36px;	
  margin: 0 0 1rem 0 !important;
  color: ${theme.colors.dark};	
  font-family: Inter;	
  font-size: 24px;	
  font-weight: bold;	
  line-height: 36px;
`;

const Body = styled(Div)`
  p {
    color: #4E5D78;	
    font-family: Inter;	
    font-size: 16px;	
    line-height: 26px;
  }
`;

function TextParagraph(props) {
  const [data, setData] = useState({});
  const ref = useRef(null);

  useEffect(() => {
    async function fetchData() {
      const result = await apiGet(`/paragraph/text/${props.id}?jsonapi_include=1`);
      setData(result.data.data);
    }
    fetchData();
  }, []);

  useEffect( () => {
    if (data.field_description && ref.current) {
      for (let c = ref.current.getElementsByTagName("a"), a = 0; a < c.length; a++) {
        let b = c[a];
        b.getAttribute("href") && b.hostname !== props.location.hostname && (b.target = "_blank")
      }
    }
  },[data, ref]);

  return (
    <Wrapper
      ref={ref}
    >
      <Title
        as={'h3'}
      >{ data.field_heading || <Skeleton/> }</Title>

      { data.field_description ?
        <Body dangerouslySetInnerHTML={{ __html: data.field_description.value}} />
        :
        <Skeleton
          count={5}
        />
      }
    </Wrapper>
  )
}



export default withRouter(TextParagraph);
